import Vue from 'vue';
import moment from 'moment';

import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import notifications from './common/plugins/notifications';
import modals from './common/plugins/modals';
import firebase from './firebase';
import { LoaderFullscreen } from './components/common';

import './styles/main.scss';

Vue.config.productionTip = false;
Vue.prototype.$moment = moment;
Vue.use(notifications);
Vue.use(modals);

const loader = new Vue({
  render: h => h(LoaderFullscreen),
}).$mount('#loader');

const unsubscribe = firebase.auth().onAuthStateChanged(async (user) => {
  loader.$destroy();
  loader.$el.remove();

  if (user) {
    await store.dispatch('user/sessionActive', user);
  }

  new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
  }).$mount('#app');
  unsubscribe();
});
